import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { customerService } from "../../services";
import "./AJoyV3.scss";
const ajoyTARGET = 3000;


class AjoyV3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: "loading",
            showCodeModal: false,
            codeDigits: ["", "", "", ""],
            amwayNumber: null,
            partyId: null,
            selectedMonth: "",
            selectedStatus: "",
            selectedOrderNo: "",
            selectedAmount: "",
            selectedReturnAmount: "0",
            selectedCount: "",
            monthlySummary: [],
            rawSubscriptions: [],
            selectedIndex: null,
            currentIndex: null,
            showNoDataModal: false,
        };
    }

    /** =========================
     *  Progress Bar helpers
     *  ========================= */
    getProgressTone = () => {
        const s = this.state.selectedStatus;
        if (s === "ซื้อแล้ว") return "green";
        if (s === "ขาดซื้อ") return "red";
        return "orange";
    };

    // คิดยอดสุทธิ = ยอดสั่งซื้อ - ยอดคืน
    getProgressInfo = () => {
        const { monthlySummary, selectedIndex, currentIndex } = this.state;


        if (!Array.isArray(monthlySummary) || monthlySummary.length === 0) {
            return { target: ajoyTARGET, net: 0, remaining: ajoyTARGET, percent: 0, isNegative: false, orderAmt: 0, returnAmt: 0 };
        }

        const idx =
            typeof selectedIndex === "number"
                ? selectedIndex
                : typeof currentIndex === "number"
                    ? currentIndex
                    : 0;

        const m = monthlySummary?.[idx] || {};
        const orderAmt = Number(m.total_order_amount || 0);
        const returnAmt = Number(m.total_return_amount || 0);
        const net = orderAmt;//- returnAmt;
        const clampedForBar = Math.max(0, Math.min(net, ajoyTARGET));
        const percent = ajoyTARGET > 0 ? (clampedForBar / ajoyTARGET) * 100 : 0;
        const remaining = Math.max(0, ajoyTARGET - net);

        return {
            target: ajoyTARGET,
            net,
            remaining,
            percent: Math.min(100, percent),
            isNegative: net < 0,
            orderAmt,
            returnAmt,
        };
    };

    /** =========================
     *  Date helpers
     *  ========================= */
    thaiMonths = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค.",];

    formatCycleCode = (cycleCode) => {
        if (!cycleCode || cycleCode.length !== 6) return cycleCode;
        const year = Number(cycleCode.slice(0, 4)) + 543;
        const month = cycleCode.slice(4, 6);
        return `${month}/${year}`;
    };

    formatCycleMonthTH = (cycleCode) => {
        if (!cycleCode || String(cycleCode).length !== 6) return "";
        const y = Number(String(cycleCode).slice(0, 4));
        const m = Number(String(cycleCode).slice(4, 6)); // 1-12
        if (!y || !m) return "";

        const monthTH = this.thaiMonths[m - 1];
        const yearTH2 = String(y + 543).slice(-2);
        return `${monthTH} ${yearTH2}`; // เช่น "ก.พ. 69"
    };

    formatActiveFromDateTH = (activateFromIso, activateToIso) => {
        if (!activateFromIso) return "";

        const toLocalDate = (iso) => {
            if (!iso) return null;
            const d = new Date(iso);
            return Number.isNaN(d.getTime()) ? null : d;
        };

        const fromD = toLocalDate(activateFromIso);
        const toD = toLocalDate(activateToIso);

        if (!fromD) return "";

        const fmtMY = (d) => {
            const month = this.thaiMonths[d.getMonth()];
            const yearTH = String(d.getFullYear() + 543).slice(-2);
            return { month, yearTH, text: `${month} ${yearTH}` };
        };

        if (!toD) return fmtMY(fromD).text;

        if (fromD.getFullYear() === toD.getFullYear() && fromD.getMonth() === toD.getMonth()) {
            return fmtMY(fromD).text;
        }

        const a = fmtMY(fromD);
        const b = fmtMY(toD);

        if (a.yearTH === b.yearTH) return `${a.month} - ${b.month} ${a.yearTH}`;

        return `${a.month} ${a.yearTH} - ${b.month} ${b.yearTH}`;
    };

    formatYearTH = (iso) => {
        if (!iso) return "";
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return "";
        return d.getFullYear() + 543;
    };

    /** =========================
 *  Data summary (for pills + progress)
 *  ========================= */
    cycleToActivateRange = (cycleCode) => {
        if (!cycleCode || String(cycleCode).length !== 6) return { from: null, to: null };

        const year = Number(String(cycleCode).slice(0, 4));
        const month = Number(String(cycleCode).slice(4, 6)); // 1-12
        if (!year || !month) return { from: null, to: null };

        const from = new Date(Date.UTC(year, month - 1, 0, 17, 0, 0)).toISOString();
        const to = new Date(Date.UTC(year, month, 0, 16, 59, 59)).toISOString();

        return { from, to };
    };

    getMonthText = (m) => {
        if (!m) return "";
        return m.isSplitCycle
            ? this.formatCycleMonthTH(m.cycleCode)
            : this.formatActiveFromDateTH(m.activate_from_date, m.activate_to_date);
    };

    isSelectedCurrentSplitMonth = () => {
        const { monthlySummary, selectedIndex, currentIndex } = this.state;
        const idx =
            typeof selectedIndex === "number"
                ? selectedIndex
                : typeof currentIndex === "number"
                    ? currentIndex
                    : -1;

        if (idx <= 0) return false;

        const m = monthlySummary?.[idx];

        if (!m) return false;

        const currentCycle = this.getCurrentCycleCode();
        return Boolean(m.isSplitCycle) && String(m.cycleCode) === String(currentCycle);
    };

    getCurrentCycleCode = () => {
        const now = new Date();
        return `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}`;
    };

    shouldSplitByCycle = (sub) => {
        const arr = sub?.amount_by_cycle;
        if (!Array.isArray(arr) || arr.length === 0) return false;

        const currentCycle = this.getCurrentCycleCode();

        const hasCurrentCycle = arr.some(
            (c) => String(c?.cycle_code) === String(currentCycle)
        );

        const firstItem = arr[0];
        const firstOrderAmt = Number(firstItem?.order_amount || 0);

        // กรณีเดือนแรกเป็น 0 และไม่มีเดือนปัจจุบันใน amount_by_cycle => ให้รวม
        if (firstOrderAmt === 0 && !hasCurrentCycle) {
            return false;
        }

        // หาเดือนก่อนหน้า
        const year = Number(currentCycle.substring(0, 4));
        const month = Number(currentCycle.substring(4, 6));
        const prevDate = new Date(year, month - 2);
        const prevCycle = `${prevDate.getFullYear()}${String(prevDate.getMonth() + 1).padStart(2, "0")}`;

        const prevItem = arr.find(
            (c) => String(c?.cycle_code) === String(prevCycle)
        );

        const sumOrder = arr.reduce((s, c) => s + Number(c?.order_amount || 0), 0);
        let totalOrder = Number(sub?.total_order_amount || 0);

        // รวมเฉพาะเคส 2 เดือน ยอดรวมถึง target
        // และเดือนก่อนหน้ายังไม่ทะลุ target
        if (
            arr.length === 2 &&
            sumOrder >= ajoyTARGET &&
            !(prevItem && Number(prevItem?.order_amount || 0) > ajoyTARGET)
        ) {
            return false;
        }

        if (prevItem && Number(prevItem?.order_amount || 0) > ajoyTARGET) {
            totalOrder = 0;
        }

        const EPS = 0.000001;
        return Math.abs(sumOrder - totalOrder) > EPS;
    };


    buildMonthlySummary = (data) => {
        if (!Array.isArray(data) || data.length === 0) return [];

        const currentCycle = this.getCurrentCycleCode(); // YYYYMM

        const summaryMap = data.reduce((acc, sub) => {
            const hasSplit = this.shouldSplitByCycle(sub);

            const cycles = hasSplit
                ? (sub.amount_by_cycle || [])
                    .map((c) => ({
                        cycle: String(c.cycle_code),
                        orderAmt: Number(c.order_amount || 0),
                        returnAmt: Number(c.return_amount || 0),
                        isSplit: true,
                    }))
                    .sort((a, b) => a.cycle.localeCompare(b.cycle))
                : [
                    {
                        cycle: String(sub.cycle_code || "unknown"),
                        orderAmt: Number(sub.total_order_amount || 0),
                        returnAmt: Number(sub.total_return_amount || 0),
                        isSplit: false,
                    },
                ];

            // หาเดือนที่จะถูก mark ACTIVE (เฉพาะเคส split)
            let splitActiveCycle = null;
            if (hasSplit) {
                const sumAll = cycles.reduce((s, c) => s + c.orderAmt, 0);

                // เดือนล่าสุดที่ "น้อยกว่า" เดือนปัจจุบัน
                const pastCycles = cycles.filter((c) => c.cycle < String(currentCycle));
                const latestPast = pastCycles.length ? pastCycles[pastCycles.length - 1].cycle : null;

                if (sumAll >= ajoyTARGET && latestPast) {
                    splitActiveCycle = latestPast; // ACTIVE ที่ "เดือนที่ผ่านมาแล้ว"
                }
            }

            cycles.forEach(({ cycle, orderAmt, returnAmt, isSplit }) => {
                if (!acc[cycle]) {
                    const isMainCycle = cycle === String(sub.cycle_code);
                    const computedRange = this.cycleToActivateRange(cycle);

                    acc[cycle] = {
                        cycleCode: cycle,
                        label: this.formatCycleCode(cycle),
                        ACTIVE: 0,
                        AWAITING: 0,
                        REVOKED: 0,
                        total_order_amount: 0,
                        total_return_amount: 0,

                        activate_from_date: isMainCycle
                            ? (sub.activate_from_date || computedRange.from)
                            : (computedRange.from || sub.activate_from_date || null),

                        activate_to_date: isMainCycle
                            ? (sub.activate_to_date || computedRange.to)
                            : (computedRange.to || sub.activate_to_date || null),

                        order_id: "",
                        coupons: [],
                        hasCoupon: false,

                        isSplitCycle: Boolean(isSplit),
                    };
                } else {
                    acc[cycle].isSplitCycle = acc[cycle].isSplitCycle || Boolean(isSplit);
                }

                const bucket = acc[cycle];
                const isMainCycle = cycle === String(sub.cycle_code);

                bucket.total_order_amount += orderAmt;
                bucket.total_return_amount += returnAmt;

                // ======= STATUS LOGIC =======
                if (hasSplit) {
                    if (splitActiveCycle && cycle === splitActiveCycle) {
                        bucket.ACTIVE = 1;
                        bucket.AWAITING = 0;
                        bucket.REVOKED = 0;
                    } else if (bucket.ACTIVE === 0 && bucket.REVOKED === 0) {
                        bucket.AWAITING = 1;
                    }
                } else {
                    if (isMainCycle) {
                        if (sub.status === "ACTIVE") bucket.ACTIVE += 1;
                        else if (sub.status === "AWAITING") bucket.AWAITING += 1;
                        else if (sub.status === "REVOKED") bucket.REVOKED += 1;
                    } else {
                        bucket.AWAITING += 1;
                    }
                }

                // order_id / coupons เฉพาะเดือนหลัก
                if (isMainCycle) {
                    const orderIds = sub?.ref_subscription?.active_order_id;
                    if (Array.isArray(orderIds) && orderIds.length > 0) bucket.order_id = orderIds[0];
                }
                if (isMainCycle && Array.isArray(sub.coupons) && sub.coupons.length > 0) {
                    bucket.coupons = sub.coupons;
                    bucket.hasCoupon = true;
                }
            });
            return acc;
        }, {});

        return Object.values(summaryMap).sort((a, b) =>
            String(a.cycleCode).localeCompare(String(b.cycleCode))
        );
    };
    preloadNotiImage = () => {
        const img = new Image();
        img.src = "/images/ajoy/ajoy-noti.png";
    };

    componentDidMount() {
        this.preloadNotiImage();
        this.checkCustomer();
    }

    componentDidUpdate(prevProps) {
        if (this.props.profile.userId !== prevProps.profile.userId) {
            this.checkCustomer();
        }
    }
    getDisplayCount = (index, total) => {
        const max = 18;
        return `${Math.min(index + 1, max)}/${Math.min(total, max)}`;
    };
    /** =========================
     *  API
     *  ========================= */
    checkCustomer() {
        const { profile } = this.props;
        if (!profile?.userId) return;

        this.setState({ status: "loading" });

        customerService
            .get(profile.userId)
            .then((res) => {
                if (res && res._id && ["abo", "member"].includes(res.type)) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/customers/ajoy`, {
                        uid: profile.userId,
                        amwayNumber: res.amwayNumber,
                        partyId: res.partyId,
                    });
                }

                this.setState({ status: "notfound", showNoDataModal: true });
                return null;
            })
            .then((response) => {
                if (!response || !Array.isArray(response.data) || response.data.length === 0) {
                    this.setState({ status: "notfound", showNoDataModal: true });
                    return;
                }

                const msg = response.data;

                if (!Array.isArray(msg) || msg.length === 0) {
                    this.setState({ status: "notfound", showNoDataModal: true });
                    return;
                }

                const monthlySummary = this.buildMonthlySummary(msg);

                let initialSelectedMonth = "";
                let initialSelectedStatus = "";
                let initialSelectedOrderNo = "";
                let initialSelectedAmount = "";
                let initialSelectedReturnAmount = "0";
                let initialSelectedCount = "";
                let currentIndex = null;
                let selectedIndex = null;

                if (monthlySummary.length > 0) {
                    const now = new Date();
                    const currentCycle = this.getCurrentCycleCode();

                    currentIndex = monthlySummary.findIndex((m) => String(m.cycleCode) === String(currentCycle));

                    if (currentIndex === -1) {
                        currentIndex = monthlySummary.findIndex((m) => {
                            const from = new Date(m.activate_from_date);
                            const to = new Date(m.activate_to_date);
                            return now >= from && now <= to;
                        });
                    }

                    if (currentIndex === -1) currentIndex = monthlySummary.findIndex((m) => m.AWAITING > 0);
                    if (currentIndex === -1) currentIndex = monthlySummary.length - 1;

                    selectedIndex = currentIndex;

                    const currentMonth = monthlySummary[currentIndex];
                    const firstRevokedIndex = monthlySummary.findIndex((m) => m.REVOKED > 0);

                    let computedStatus = "";
                    if (currentMonth.REVOKED > 0 && currentIndex === firstRevokedIndex) computedStatus = "ขาดซื้อ";
                    else if (firstRevokedIndex !== -1 && currentIndex > firstRevokedIndex) computedStatus = "หมดสิทธิ์";
                    else if (currentMonth.ACTIVE > 0) computedStatus = "ซื้อแล้ว";
                    else computedStatus = "รอสั่งซื้อ";

                    initialSelectedMonth = this.getMonthText(currentMonth);
                    initialSelectedStatus = computedStatus;

                    initialSelectedReturnAmount = Number(currentMonth.total_return_amount || 0).toLocaleString();

                    if (computedStatus === "ซื้อแล้ว") {
                        initialSelectedOrderNo = currentMonth.order_id || "";
                        initialSelectedAmount = Number(currentMonth.total_order_amount || 0).toLocaleString();
                    } else {
                        initialSelectedOrderNo = "";
                        initialSelectedAmount = "";
                    }

                    if (computedStatus === "ขาดซื้อ" || computedStatus === "หมดสิทธิ์") {
                        initialSelectedOrderNo = "";
                        initialSelectedAmount = "";
                    }
                    initialSelectedCount = this.getDisplayCount(currentIndex, monthlySummary.length);
                }

                this.setState({
                    status: "ajoy",
                    rawSubscriptions: msg,
                    monthlySummary,
                    selectedMonth: initialSelectedMonth,
                    selectedStatus: initialSelectedStatus,
                    selectedOrderNo: initialSelectedOrderNo,
                    selectedAmount: initialSelectedAmount,
                    selectedReturnAmount: initialSelectedReturnAmount,
                    selectedCount: initialSelectedCount,
                    currentIndex,
                    selectedIndex,
                });
            })
            .catch(() => {
                this.setState({ status: "notfound", showNoDataModal: true });
            });
    }

    /** =========================
     *  Modals / Actions
     *  ========================= */
    handleConfirm = () => {
        this.setState({ showCodeModal: true }, () => {
            if (this.digit0) this.digit0.focus();
        });
    };

    handleCancelCode = () => {
        this.setState({ showCodeModal: false, codeDigits: ["", "", "", ""] });
        if (window.liff && typeof window.liff.closeWindow === "function") window.liff.closeWindow();
        else window.close();
    };

    handleShowValue = (month, status, orderNo, amount, returnAmount, count, index) => {
        this.setState({
            selectedMonth: month,
            selectedStatus: status,
            selectedOrderNo: orderNo,
            selectedAmount: amount,
            selectedReturnAmount: returnAmount ?? "0",
            selectedCount: count,
            selectedIndex: index,
        });
    };

    handleClose = () => {
        if (window.liff && typeof window.liff.closeWindow === "function") window.liff.closeWindow();
        else window.close();
    };

    closeTermsModal = () => {
        this.setState({ status: "ajoy" });
    };

    /** =========================
     *  Render pieces
     *  ========================= */
    renderTerms() {
        return (
            <div className="ajoy3 fullscreen">
                <div className="ajoy-terms-wrapper">
                    <div className="ajoy-terms-card">
                        <div className="ajoy-terms-pill">เงื่อนไขการร่วมกิจกรรม A JOY</div>

                        <div className="ajoy-terms-content">
                            <div className="ajoy-terms-title">เงื่อนไขการร่วมกิจกรรม A JOY</div>
                            <ol className="ajoy-terms-list">
                                <li>
                                    การยอมรับข้อกำหนด<br />
                                    เมื่อคุณใช้บริการนี้ ถือว่าคุณยอมรับและตกลงปฏิบัติตามข้อกำหนด และเงื่อนไขเหล่านี้
                                </li>
                                <li>
                                    การใช้งานบริการ<br />
                                    คุณตกลงที่จะใช้บริการเพื่อวัตถุประสงค์ที่ถูกต้องตามกฎหมาย และจะไม่กระทำการใด ๆ
                                    ที่อาจก่อให้เกิดความเสียหาย รบกวน หรือรบเร้าแก่การทำงานของบริการ
                                </li>
                                <li>
                                    ความรับผิดชอบของบัญชีผู้ใช้<br />
                                    หากคุณลงทะเบียนบัญชี คุณมีหน้าที่รับผิดชอบในการเก็บรักษาข้อมูลเข้าสู่ระบบของคุณไว้เป็นความลับ
                                    และรับผิดชอบต่อการกระทำใด ๆ ที่เกิดขึ้นผ่านบัญชีของคุณ
                                </li>
                                <li>
                                    ทรัพย์สินทางปัญญา<br />
                                    เนื้อหา เครื่องหมายการค้า และสื่อทั้งหมดที่ให้บริการนี้เป็นทรัพย์สินของบริษัทหรือผู้ให้อนุญาต
                                    คุณไม่สามารถทำซ้ำหรือเผยแพร่โดยไม่ได้รับอนุญาต
                                </li>
                                <li>
                                    การจำกัดความรับผิดชอบ<br />
                                    บริษัทจะไม่รับผิดชอบต่อความเสียหายใด ๆ ไม่ว่าจะโดยตรง โดยอ้อม หรือโดยบังเอิญ
                                    ที่เกิดจากการใช้งานบริการของคุณ
                                </li>
                                <li>
                                    การระงับหรือยกเลิกการให้บริการ<br />
                                    เราขอสงวนสิทธิ์ในการระงับหรือยกเลิกการเข้าถึงบริการได้ทุกเมื่อ โดยไม่ต้องแจ้งล่วงหน้า
                                    หากมีการละเมิดข้อกำหนดและเงื่อนไขเหล่านี้
                                </li>
                                <li>
                                    การเปลี่ยนแปลงเงื่อนไข<br />
                                    บริษัทขอสงวนสิทธิ์ในการแก้ไขหรือเปลี่ยนแปลงเงื่อนไขได้ตามความเหมาะสม
                                    โดยจะแจ้งให้ทราบล่วงหน้าเมื่อมีการปรับปรุง
                                </li>
                            </ol>
                        </div>
                    </div>

                    <button className="ajoy-terms-close-btn" onClick={this.closeTermsModal}>
                        ปิด
                    </button>
                </div>
            </div>
        );
    }

    renderNoDataModal() {
        return (
            <div className="ajoy-modal-overlay">
                <div className="ajoy-modal-card">
                    <div className="ajoy-modal-logo">
                        <img src="/images/ajoy/ajoy-noti.png" alt="A Joy" className="ajoy-noti-logo" />
                    </div>

                    <div className="ajoy-modal-title">ขออภัย</div>
                    <div className="ajoy-modal-title">คุณไม่ได้รับสิทธิ์การเข้าร่วมกิจกรรม A JOY</div>
                    <div className="ajoy-modal-text">
                        สั่งซื้อต่อเนื่อง รับคูปองเงินสด{" "}
                        <span
                            className="ajoy-modal-link"
                            onClick={() => {
                                if (window.liff) {
                                    window.liff.openWindow({
                                        url: `${process.env.REACT_APP_AJOY_TC}`,
                                        external: false,
                                    });
                                } else {
                                    window.open(`${process.env.REACT_APP_AJOY_TC}`, "_blank");
                                }
                            }}
                        >
                            อ่านรายละเอียดคลิก
                        </span>
                    </div>

                    <button className="ajoy-modal-btn" onClick={this.handleClose}>
                        ปิด
                    </button>
                </div>
            </div>
        );
    }

    renderHeader() {
        return (
            <div className="headerBar">
                <div
                    className="headerBar-link"
                    onClick={() => {
                        if (window.liff) {
                            window.liff.openWindow({
                                url: `https://liff.line.me/${process.env.REACT_APP_LIFF_CLIENT_ID_COUPON}`,
                                external: false,
                            });
                        } else {
                            window.open(`https://liff.line.me/${process.env.REACT_APP_LIFF_CLIENT_ID_COUPON}`, "_blank");
                        }
                    }}
                />
            </div>
        );
    }

    renderAJoy() {
        const { monthlySummary, currentIndex, selectedIndex } = this.state;
        const firstRevokedIndex = monthlySummary.findIndex((m) => m.REVOKED > 0);

        const progress = this.getProgressInfo();
        const tone = this.getProgressTone();
        const hideProgress = this.state.selectedStatus === "หมดสิทธิ์";

        const idx = typeof selectedIndex === "number"
            ? selectedIndex
            : typeof currentIndex === "number"
                ? currentIndex
                : 0;

        const m = monthlySummary?.[idx] || {};
        const net = Number(m.total_order_amount || 0);//- Number(m.total_return_amount || 0);
        const showSplitWarning =
            (selectedIndex === currentIndex &&
                this.state.selectedStatus !== "ขาดซื้อ" &&
                this.state.selectedStatus !== "หมดสิทธิ์" &&
                idx > 0 && net >= ajoyTARGET) ||
            (selectedIndex === currentIndex &&
                this.state.selectedStatus !== "ขาดซื้อ" &&
                this.state.selectedStatus !== "หมดสิทธิ์" &&
                this.isSelectedCurrentSplitMonth() && net <= ajoyTARGET);

        const showOrderBtn =
            (selectedIndex === currentIndex &&
                this.state.selectedStatus !== "ขาดซื้อ" &&
                this.state.selectedStatus !== "หมดสิทธิ์" &&
                net < ajoyTARGET);
        const isGreen = this.state.selectedStatus === "ซื้อแล้ว" || net >= ajoyTARGET;
        return (
            <div className="ajoy3 fullscreen">
                {this.renderHeader()}

                <div className="containerNotFound">
                    <div className="ajoy-card">
                        <div className="ajoy-card-header">
                            <div className="title">ตารางสะสมยอด</div>
                            <div
                                className="condition-link"
                                onClick={() => {
                                    if (window.liff) {
                                        window.liff.openWindow({
                                            url: `${process.env.REACT_APP_AJOY_TC}`,
                                            external: false,
                                        });
                                    } else {
                                        window.open(`${process.env.REACT_APP_AJOY_TC}`, "_blank");
                                    }
                                }}
                            >
                                เงื่อนไขการร่วมกิจกรรม
                            </div>
                        </div>

                        <div className="ajoy-month-grid">
                            {monthlySummary &&
                                monthlySummary.map((m, index) => {
                                    if (index > 17) return null; //แสดง 18 ครั้งพอ
                                    const isPurchased = m.ACTIVE > 0;
                                    const isRevoked = m.REVOKED > 0;
                                    const isCurrent = index === currentIndex;
                                    const isExpired = firstRevokedIndex !== -1 && index > firstRevokedIndex;

                                    const showBadge = (index + 1) % 3 === 0;
                                    const monthLabel = `ครั้งที่ ${index + 1}`;

                                    if (isExpired) {
                                        return (
                                            <div
                                                key={m.cycleCode}
                                                name={m.cycleCode}
                                                className={`month-pill reward ${this.state.selectedIndex === index ? "bold" : ""}`}
                                                onClick={() =>
                                                    this.handleShowValue(
                                                        this.getMonthText(m),
                                                        "หมดสิทธิ์",
                                                        "",
                                                        "",
                                                        Number(m.total_return_amount || 0).toLocaleString(),
                                                        this.getDisplayCount(index, monthlySummary.length),
                                                        index
                                                    )
                                                }
                                            >
                                                หมดสิทธิ์
                                                {showBadge && <span className="badge-gray"></span>}
                                            </div>
                                        );
                                    }

                                    if (isRevoked) {
                                        return (
                                            <div
                                                key={m.cycleCode}
                                                name={m.cycleCode}
                                                className={`month-pill redorder ${this.state.selectedIndex === index ? "bold" : ""}`}
                                                onClick={() =>
                                                    this.handleShowValue(
                                                        this.getMonthText(m),
                                                        "ขาดซื้อ",
                                                        "",
                                                        "",
                                                        Number(m.total_return_amount || 0).toLocaleString(),
                                                        this.getDisplayCount(index, monthlySummary.length),
                                                        index
                                                    )
                                                }
                                            >
                                                ขาดซื้อ
                                            </div>
                                        );
                                    }

                                    if (isPurchased) {
                                        return (
                                            <div
                                                key={m.cycleCode}
                                                name={m.cycleCode}
                                                className={`month-pill success ${this.state.selectedIndex === index ? "bold" : ""}`}
                                                onClick={() =>
                                                    this.handleShowValue(
                                                        this.getMonthText(m),
                                                        "ซื้อแล้ว",
                                                        m.order_id || "",
                                                        Number(m.total_order_amount || 0).toLocaleString(),
                                                        Number(m.total_return_amount || 0).toLocaleString(),
                                                        this.getDisplayCount(index, monthlySummary.length),
                                                        index
                                                    )
                                                }
                                            >
                                                {showBadge && !m.hasCoupon ? (
                                                    <>
                                                        <span className="badge-text" style={{ fontWeight: isCurrent ? "bold" : "normal" }}>รอรับ</span>
                                                        <span className="badge"></span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="check-icon"></span>
                                                        {showBadge && (
                                                            <span className="badge-text" style={{ fontWeight: isCurrent ? "bold" : "normal" }}>รับแล้ว</span>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        );
                                    }

                                    return (
                                        <div
                                            key={m.cycleCode}
                                            name={m.cycleCode}
                                            className={`month-pill ${isCurrent ? "current" : ""} ${selectedIndex === index ? "selected" : ""}`}
                                            onClick={() =>
                                                this.handleShowValue(
                                                    this.getMonthText(m),
                                                    "รอสั่งซื้อ",
                                                    "",
                                                    "",
                                                    Number(m.total_return_amount || 0).toLocaleString(),
                                                    this.getDisplayCount(index, monthlySummary.length),
                                                    index
                                                )
                                            }
                                        >
                                            {monthLabel}
                                            {showBadge && <span className="badge"></span>}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>

                    {showSplitWarning && (
                        <div className="ajoy-card">
                            <div className="ajoy-start-condition-row">
                                <div className="ajoy-start-condition-left">เงื่อนไขการซื้อเดือนเริ่มต้น</div>
                                <div
                                    className="ajoy-start-condition-right"
                                    onClick={() => {
                                        if (window.liff) {
                                            window.liff.openWindow({ url: `${process.env.REACT_APP_AJOY_TC}`, external: false });
                                        } else {
                                            window.open(`${process.env.REACT_APP_AJOY_TC}`, "_blank");
                                        }
                                    }}
                                >
                                    อ่านรายละเอียด
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="ajoy-bottom-card">
                        <div className="order-info">
                            <div className="order-left">
                                <span
                                    className={
                                        this.state.selectedStatus === "ขาดซื้อ"
                                            ? "order-icon-red"
                                            : this.state.selectedStatus === "หมดสิทธิ์"
                                                ? "order-icon-gray"
                                                : isGreen
                                                    ? "order-icon-green"
                                                    : "order-icon-gray"
                                    }
                                ></span>

                                <span className="order-month">{this.state.selectedMonth}</span>
                                <span
                                    className={
                                        this.state.selectedStatus === "ขาดซื้อ"
                                            ? "order-status-red"
                                            : this.state.selectedStatus === "หมดสิทธิ์"
                                                ? "order-status-gray"
                                                : isGreen
                                                    ? "order-status-green"
                                                    : "order-status-gray"
                                    }
                                >
                                    {this.state.selectedStatus}
                                </span>
                            </div>
                            <div className="order-count">{this.state.selectedCount}</div>
                        </div>

                        {/* Progress Bar */}
                        {!hideProgress && (
                            <div className={`ajoy-progress tone-${tone}`}>
                                <div className="ajoy-progress-top">
                                    <div className="ajoy-progress-title">ยอดสะสม</div>
                                </div>

                                <div className="ajoy-progress-bar">
                                    <div className="ajoy-progress-fill" style={{ width: `${progress.percent}%` }} />
                                </div>

                                <div className="ajoy-progress-bottom">
                                    <span className={`ajoy-progress-left ${Number(progress.net || 0) === 0 ? "zero" : ""}`} >
                                        {Number(progress.net || 0).toLocaleString()}
                                        {progress.remaining > 0 ? (
                                            <span className="ajoy-progress-remain">
                                                {" "} (ขาดอีก {Number(progress.remaining || 0).toLocaleString()})
                                            </span>
                                        ) : (
                                            <span className="ajoy-progress-remain"></span>
                                        )}
                                    </span>

                                    <span className="ajoy-progress-right">
                                        {Number(progress.target || 0).toLocaleString()}
                                    </span>
                                </div>

                                {/* ยอดคืน */}
                                <div className="ajoy-divider" />
                                <div className="order-info detailorder">
                                    <div className="order-left">
                                        <span className="order-month-detail">ยอดคืน</span>
                                    </div>
                                    <div className="order-count-detail" name={Number(progress.orderAmt || 0).toLocaleString()}>
                                        {Number(progress.returnAmt || 0).toLocaleString()}
                                    </div>
                                </div>
                                <div className="ajoy-divider" />
                            </div>
                        )}

                        {showSplitWarning && (
                            <div className="order-warning-split">*ยอดเดือนนี้จะไม่สะสมในเดือนถัดไป</div>
                        )}

                        {showOrderBtn && (
                            <button className="order-button" onClick={() => (window.location.href = "line-ordering?isInstallment=FALSE")}>
                                สั่งซื้อเลย
                            </button>
                        )}

                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { status, showNoDataModal } = this.state;
        return (
            <>
                <style></style>
                {status === "loading" && (
                    <div className="ajoy3 fullscreen loading-center">
                        <img src="/images/ajoy/ajoy-load-new.gif" alt="loading" className="ajoy-loading-gif" />
                    </div>
                )}
                {status === "ajoy" && this.renderAJoy()}
                {status === "notfound" && showNoDataModal && <div className="ajoy3 fullscreen">{this.renderNoDataModal()}</div>}
                {status === "terms" && this.renderTerms()}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    profile: state.profile,
});

export default connect(mapStateToProps)(AjoyV3);
